import { render } from "./WhitelabelHome.vue?vue&type=template&id=30a3e810&scoped=true&ts=true"
import script from "./WhitelabelHome.vue?vue&type=script&lang=ts"
export * from "./WhitelabelHome.vue?vue&type=script&lang=ts"

import "./WhitelabelHome.vue?vue&type=style&index=0&id=30a3e810&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30a3e810"]])

export default __exports__